export const SIGNIN_ROUTE = "/signin";
export const SIGNUP_ROUTE = "/signup";
export const INITIAL_ROUTE = "/";
export const DASHBOARD_ROUTE = "/dashboard";
export const FORGOT_PASSWORD = "/forgotpassword";
export const USER_LOG_ROUTE = "/userlog";
export const SIDEBAR = "/sidebar";
export const CHANGE_PASSWORD = "/changepassword";
export const EMAIL_CONFIRMATION = "/email-confirmation";
export const USERS_ROUTE = "/users";
export const USERS_DETAILS = "/user-details/:id";
// export const USERS_DETAILS = "/user-details/";
export const CUSTOMERS_ROUTE = "/customers";
export const USER_FILTER_PROPERTIES = "/filter";
export const CUSTOMER_HISTORY = "/customer-history";
export const CUSTOMER_FILTER_MODEL = "/csfilter";
export const ADD_CUSTOMER = "/add-customer/";
export const CUSTOMER_DETAILS = "/customer-details/:id";
export const USER_FILTER = "/user-filter";
export const CLEAR_FILTER = "/clear-filter";
export const PROJECTS_ROUTE = "/projects";
export const ADD_PROJECT = "/add-project";
export const PROJECT_DETAILS = "/project-details/:id";
export const DAILY_ENTRY_ROUTE = "/daily-entry";
export const CREATE_NEW_ACCOUNT_MODEL = "/account-model";
export const BILLING_STATEMENT_LIST_ROUTE = "/billingstatement";
export const BILLING_STATEMENT = "/statement/:bid";
export const BILLING_ATTACHMENT = "/attachment";

// Admin billings
export const ADMIN_BILLING_LIST = "/adminbillingstatement";
export const ADMIN_BILLING_HISTORY = "/adminBillingHistory";
export const ADMIN_BILLING_STATEMENT = "/orphaned-statement/:id";

export const INVOICE_LIST = "/invoices";
export const PAGE_NOT_FOUND_PATH = "*";
export const ACCOUNT_LOCKED_PATH = "/locked";

export const INVOICE_FORM = "/invoice-form/:id";
export const CONSOLIDATED_INVOICE_LIST = "/consolidated-invoice-list";
export const CONSOLIDATED_INVOICE_FORM = "/consolidated-invoice-form/:id";
export const PRINT_INVOICE_FORM = "/print-invoice-form/:id";
export const PRINT_BROKER_FORM = "/print-broker-form";
export const PRINT_BILLING_STATEMENT = "/print-billing-statements/:id";
export const PRINT_ADMIN_BILLING_STATEMENT = "/print-billing-statement/:id";
export const PRINT_DASHBOARD_BILLING_STATEMENT =
  "/print-dashboard-billing-statements/:id";
export const PRINT_ORPHANED_BILLING_STATEMENT =
  "/print-orphaned-billing-statements/:id";
export const PRINT_CONSOLIDATED_INVOICE_FORM =
  "/print-consolidatedinvoice-form/:id";
export const BILLING_INFO_MODEL = "/info";
export const PRINT_CUSTOMER = "/report-dashboard/:id";
export const BILLING_REVIEW = "/billing-review";
